module.exports = __webpack_public_path__ + "img/jinianri.1a210578.jpg";